/* globals window */

import { PureComponent } from 'react';
import { sendGAEvent } from '!/common/helpers';

class PaginationItem extends PureComponent {
  handleClick = event => {

    sendGAEvent('Search', 'Pagination Click', this.props.pageNumber);

    event.preventDefault();
    this.props.handleClick(this.props.pageNumber);
    window.scrollTo(0, 0);
  };

  render() {
    const { ariaLabel, label, isActive, url, pageNumber, query } = this.props;

    return (
      <li className={`pagination__item${isActive ? ' pagination__item--active' : ''}`}>
        <a
          onClick={this.handleClick}
          href={url}
          tabIndex="0"
          aria-label={ariaLabel}
          onKeyPress={this.handleClick}
          rel={query ? 'nofollow' : null}
        >
          {label}
        </a>
      </li>
    );
  }
}

export default PaginationItem;
